function isUrlSet(request?: { url: string }): boolean {
  return Boolean(request && request.url !== null && request.url !== "");
}

export default isUrlSet;
